namespace RecordShield.Wallet {
    export interface TransactionsRow {
        Id?: number;
        TransactionId?: string;
        TransactionStatus?: Models.PaymentStatus;
        Amount?: number;
        CouponId?: number;
        DiscountAmount?: number;
        CreditConfigId?: number;
        TenantId?: number;
        IsActive?: number;
        CouponCouponCode?: string;
        CouponFromDate?: string;
        CouponToDate?: string;
        CouponCouponType?: number;
        CouponSpecificUsers?: string;
        CouponDiscountType?: number;
        CouponDiscountPercentage?: number;
        CouponDiscountAmount?: number;
        CouponIsActive?: number;
        CreditConfigFromGb?: number;
        CreditConfigUptoGb?: number;
        CreditConfigCredits?: number;
        CreditConfigValidFrom?: string;
        CreditConfigValidThru?: string;
        CreditConfigIsActive?: boolean;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace TransactionsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'TransactionId';
        export const localTextPrefix = 'Wallet.Transactions';

        export namespace Fields {
            export declare const Id: string;
            export declare const TransactionId: string;
            export declare const TransactionStatus: string;
            export declare const Amount: string;
            export declare const CouponId: string;
            export declare const DiscountAmount: string;
            export declare const CreditConfigId: string;
            export declare const TenantId: string;
            export declare const IsActive: string;
            export declare const CouponCouponCode: string;
            export declare const CouponFromDate: string;
            export declare const CouponToDate: string;
            export declare const CouponCouponType: string;
            export declare const CouponSpecificUsers: string;
            export declare const CouponDiscountType: string;
            export declare const CouponDiscountPercentage: string;
            export declare const CouponDiscountAmount: string;
            export declare const CouponIsActive: string;
            export declare const CreditConfigFromGb: string;
            export declare const CreditConfigUptoGb: string;
            export declare const CreditConfigCredits: string;
            export declare const CreditConfigValidFrom: string;
            export declare const CreditConfigValidThru: string;
            export declare const CreditConfigIsActive: string;
            export declare const InsertUserId: string;
            export declare const InsertDate: string;
            export declare const UpdateUserId: string;
            export declare const UpdateDate: string;
        }

        ['Id', 'TransactionId', 'TransactionStatus', 'Amount', 'CouponId', 'DiscountAmount', 'CreditConfigId', 'TenantId', 'IsActive', 'CouponCouponCode', 'CouponFromDate', 'CouponToDate', 'CouponCouponType', 'CouponSpecificUsers', 'CouponDiscountType', 'CouponDiscountPercentage', 'CouponDiscountAmount', 'CouponIsActive', 'CreditConfigFromGb', 'CreditConfigUptoGb', 'CreditConfigCredits', 'CreditConfigValidFrom', 'CreditConfigValidThru', 'CreditConfigIsActive', 'InsertUserId', 'InsertDate', 'UpdateUserId', 'UpdateDate'].forEach(x => (<any>Fields)[x] = x);
    }
}
